import { Component, Input, OnInit } from "@angular/core";
import { ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LoggedInUserInformationService, LOGIN_INFO_REDUCER_NAME, UserInfo, UserInfoStateStructure } from "@ptl/account-management";
import { RedirectService } from "src/app/angular-elements/shared/services/redirect.service";
import { ReducerUtilityService } from "src/app/shared/utility-services/reducer-utility.service";
import { environment } from 'src/environments/environment';
import { ConnectureEnrollPermissionsService } from "../connecture-enroll/connecture-enroll-sso-permissions.service";

/**
 * @deprecated This component is being held in case sales force abruptly needs another SSO.
 * The AEM configuration is already set up and ready to use this component
 */
@Component({
    selector: 'app-sales-force-uat-sso',
    templateUrl: './sales-force-uat-sso.component.html',
    styleUrls: ['./sales-force-uat-sso.component.scss'],
    standalone: false
})
export class SalesForceUatSsoComponent {
   
  @Input() label;
  @Input() lob: LINE_OF_BUSINESS_ENUM;
    
  userInfo: UserInfo = null;
  userId = '';
  isSalesForceInternal = false;
  isSalesForceExternal = false;
  isLoading = false;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private redirectService: RedirectService,
    private entitlementHelper: EntitlementsHelperService,
    private connecturePermissionService: ConnectureEnrollPermissionsService
  ) { }

  async ngOnInit() {
    if (!this.lob) {
      this.lob = await this.entitlementHelper.getCurrentLobPromise();
    }

    this.isSalesForceInternal = this.entitlementHelper.entitlementValueByNameAndLob(ENTITLEMENTS.SALES_FORCE_INTERNAL, this.lob);
    this.isSalesForceExternal = this.entitlementHelper.entitlementValueByNameAndLob(ENTITLEMENTS.SALES_FORCE_EXTERNAL, this.lob);

    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    this.userInfo = loginInfo.userInfo;
    this.userId = loginInfo.userId;
  }
  
  // Due to a salesforce restriction, we require 3 separate sso links so we can test ALL of them in any environment.
  // We cannot refactor the destinationURL into the 'environments' architecture 
  async submitForm() {
    this.isLoading = true;

    // Connecture is only applicable for Senior Markets
    let shouldUpdateConnecture = this.lob === LINE_OF_BUSINESS_ENUM.SENIOR || this.lob === LINE_OF_BUSINESS_ENUM.DSNP;

    // We have to update connecture SSO selling permissions here because the user can go directly to connecture from salesforce
    // If we do not do this, the connecture permissions have a chance to be out of sync because they are only updated through our SSO
    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    if (!shouldUpdateConnecture || await this.connecturePermissionService.setupConnecturePermissionsForSSO(loginInfo, this.lob, false)) {
      let destinationURL;
      
      if (this.isSalesForceInternal) {
        destinationURL = 'SFHCTRNINTERNAL';
      }
      else if (this.isSalesForceExternal) {
        destinationURL = 'SFHCTRNBROKER';
      }
      
      let target = "https://" + environment.external.vendors.agentCubeUrl;
      let postParams = { userName: this.userId, destinationURL: destinationURL, target }
      this.redirectService.post(postParams);
    }
    else {
      this.connecturePermissionService.showSSOError();
    }

    this.isLoading = false;
  }
}
